export const formContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  paddingTop: '24px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const previousAddressFormControlsStyles = {
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-end',
};

export const addAnotherEntityStyles = {
  marginTop: '24px',
};

export const sectionStyles = {
  marginBottom: '64px',

  '&:last-child': {
    marginBottom: 0,
  },
};

export const containerStyles = {
  paddingBottom: '60px',
};

export const realtorPickerWrapperStyles = {
  marginBottom: '16px',
};
